
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
.btn.none {
  font-weight: var(--fw-bold) !important;
}@media (min-width: 1280px) {.btn.none {
    font-size: var(--fs-xs) !important;
    line-height: var(--lh-xs) !important;
  }
}@media (min-width: 1440px) {.btn.none {
    font-size: var(--fs-base) !important;
    line-height: var(--lh-base) !important;
  }
}

@media (max-width: 1280px){
  .btn.none{
    padding-top:0px;
  }
}
`;